import { ThermometerBluetoothIcon } from './ThermometerBluetoothIcon';

/**
 * author: Michael Irigoyen
 * id D3767EC9-5C06-42A0-B6BE-F5D2CF89FFD1
 * name thermometer-bluetooth
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-bluetooth.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Automotive 
 */
export const TemperatureBluetoothIcon = ThermometerBluetoothIcon;
export default TemperatureBluetoothIcon